import React from "react";
import FileViewer from "react-file-viewer";
// @ts-ignore
import { tw } from "@careinfo/tailwind";

const Preview = ({ selectedFile, setSelectedFile }) => {
  const handleClose = () => setSelectedFile(null);
  const onError = (e: any) => {
    console.error("Error loading file:", e);
  };

  if (!selectedFile) return null;

  const { type: fileType, url: filePath, title } = selectedFile;
  const imageTypes = ["jpg", "jpeg", "png", "gif", "webp"];
  const docTypes = ["pdf", "docx", "xlsx", "pptx", "txt", "csv", "md"];

  return (
    <div
      className={tw`fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center z-50`}
      onClick={handleClose}
    >
      <div
        className={tw`bg-white rounded shadow-lg p-4 max-w-4xl w-full max-h-[90vh] overflow-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={tw`flex justify-between items-center mb-4`}>
          <h2 className={tw`text-lg font-semibold`}>{title}</h2>
          <button
            className={tw`text-gray-600 hover:text-black text-xl`}
            onClick={handleClose}
          >
            &times;
          </button>
        </div>

        <div className={tw`w-full h-[70vh] overflow-auto`}>
          {imageTypes.includes(fileType) ? (
            <img
              src={filePath}
              alt="Preview"
              className={tw`max-w-full max-h-full mx-auto object-contain`}
              onError={onError}
            />
          ) : docTypes.includes(fileType) ? (
            <div className={tw`w-full h-full`}>
              <FileViewer
                fileType={fileType}
                filePath={filePath}
                onError={onError}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Preview;
